import React, { useState } from 'react';

import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

import { styled } from '@mui/system';
import { CheckBox as CheckIconActive, CheckBoxOutlineBlank as CheckIconNotActive} from '@mui/icons-material';

const CheckBoxStyle = styled(FormGroup)(({ theme }) => ({
    minHeight: theme.spacing(6),
    height: "fit-content",
    width: '100%',
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1,2),
    justifyContent: 'center',
}));


const CheckBox = (props) => {

  const [checked, setChecked] = useState(props.value);

  const handleChange = () => {
    const toggleCheck = !checked;
    setChecked(toggleCheck);
    props.handlechange(toggleCheck.toString());
  };
  
  const requiredAddon = () => {
    return props.required && <span style={{color: 'var(--mui-palette-red-900)'}}> *</span>;
  }
  
  return (
    <>
      <CheckBoxStyle className='BoxShadow'>
        <FormControlLabel 
          label={<span>{props.label}{requiredAddon()}</span> } 
          control={ 
            <Checkbox 
              checked={checked} 
              value={checked}
              checkedIcon={ checked ? <CheckIconActive/> : <CheckIconNotActive /> }
              onClick={handleChange} 
              name={props.name}
              /> 
            } 
        />
      </CheckBoxStyle>
    </>
  );
}

export default CheckBox;
